import { createAssign } from "robodux";
import { call, put } from "saga-query";

import { ThunkCtx, thunks } from "../../apis/api";
import { RootState } from "../../rootState";
import { startingScript } from "../fileSys";

export const uiFileOps = createAssign<any>({
  name: "ui/fileops",
  initialState: {
    fileName: "",
    timespan: "each_to_the_end" as
      | "each_to_the_end"
      | "each_month"
      | "each_3_months"
      | "each_year"
      | "two_batches"
      | "three_batches",
  },
});

const selectUiFOps = (state: RootState) => state[uiFileOps.name];

type TScriptSpan =
  | "each_to_the_end"
  | "each_month"
  | "each_3_months"
  | "each_year"
  | "two_batches"
  | "three_batches";
type TStartScript = {
  fileName: string;
  timespan: TScriptSpan;
};
export const startScript = thunks.create<TStartScript>(
  "thunks/fileManager/startScript",
  // {saga: latest},
  function* (ctx: ThunkCtx, next) {
    // yield* call()
    yield* put(
      uiFileOps.actions.set({
        fileName: ctx.payload.fileName,
        timespan: ctx.payload.timespan,
      })
    );
    yield* call(startingScript.run, startingScript(ctx.payload));
    yield* next();
  }
);
